import PropTypes from "prop-types";
import React from "react";
import Slider from "react-slick";
import styles from "./styles.css";
import UspCard from "./UspCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
import { CMS_SLUG_CONSTANTS } from "../../../constants/optimize-constants";

const ListingUspCarousel = ({ cmsConfig }) => {
    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2.8,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true
    };

    const luxuryCarouselSection = getPageSectionByName(cmsConfig?.data?.pageSections, CMS_SLUG_CONSTANTS.LUXURY_CAROUSEL_CDP);
    const luxuryCarouselContent = luxuryCarouselSection?.meta;

    if (!luxuryCarouselContent?.cards?.length) {
        return null;
    }

    return (
        <div styleName="styles.carouselWrapper">
            <Slider {...sliderSettings}>
                {luxuryCarouselContent.cards.map((card, index) => (
                    <UspCard
                        key={index}
                        title={card.title}
                        description={card.content}
                        icon={luxuryCarouselContent.icons}
                    />
                ))}
            </Slider>
        </div>
    );
};

ListingUspCarousel.propTypes = {
    cmsConfig: PropTypes.object
};

export default ListingUspCarousel;
